import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const RECEIVE_PARTNER = 'RECEIVE_PARTNER'
export const REQUEST_PARTNER = 'REQUEST_PARTNER'
export const SAVE_PARTNER = 'SAVE_PARTNER'
export const UPDATE_AND_SAVE_PARTNER = 'UPDATE_AND_SAVE_PARTNER'
export const REFER_PARTNER = 'REFER_PARTNER'

export const requestPartner = () => (dispatch, getState) => {
    dispatch({ type: REQUEST_PARTNER })

    const { profile } = getState()

    const { id: userId } = profile

    axios
        .get(`/partners/${userId}`)
        .then((response) => {
            const data = response?.data || {}
            dispatch(receivePartner({ ...data, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receivePartner({ fetchSuccessful: true }))
                return
            }

            dispatch(receivePartner({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receivePartner = (data) => ({ type: RECEIVE_PARTNER, data })

export const updateAndSavePartner = (data, options) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_PARTNER, data })

    dispatch(receivePartner(data))
    return dispatch(savePartner(options))
}

export const savePartner =
    ({ hideAlert } = {}) =>
    (dispatch, getState) => {
        dispatch({ type: SAVE_PARTNER })

        const { profile, partner } = getState()

        const { id: userId } = profile

        return axios
            .put(`/partners/${userId}`, { ...partner, userId })
            .then((response) => {
                dispatch(receivePartner(response.data))

                if (!hideAlert) {
                    dispatch(receiveSuccessAlert('Información de tu pareja actualizada'))
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const referPartner = () => (dispatch, getState) => {
    dispatch({ type: REFER_PARTNER })

    const { profile } = getState()

    const { id: userId } = profile

    return axios
        .post(`/partners/${userId}/refer`)
        .then((response) => {
            const data = response?.data || {}
            dispatch(receivePartner({ ...data, fetchSuccessful: true }))

            dispatch(receiveSuccessAlert('Se ha enviado una invitación a tu pareja'))
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receivePartner({ fetchSuccessful: true }))
                return
            }

            dispatch(handleRequestError(error))
        })
}
